import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { CalendarId } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';
import * as trace from 'owa-trace';

export const instantRenameCalendar = mutatorAction(
    'instantRenameCalendar',
    (id: CalendarId, newCalendarName: string) => {
        const calendars = getStore().calendars;
        let foundCalendarResult = findInArray(calendars, item => {
            return item.id.id == id.id;
        });

        if (foundCalendarResult) {
            // mutate the calendar object in the calendars list so that the
            // change gets reflected in selectedCalendars list as well
            calendars[foundCalendarResult.index].displayName = newCalendarName;
        } else {
            trace.errorThatWillCauseAlert(`[renameCalendar] Cannot find calendar id: ${id}`);
        }
    }
);
